// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3gGBV","title":"AfterBackImages_title__2R-BF","images":"AfterBackImages_images__3XltB"};